<template>
  <div class="allActiveGradeSubDetail">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="9"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{
              startDate: searchForm.startDate,
              endDate: searchForm.endDate
            }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="6"
          ><span class="title">年级:</span>
          <el-select
            v-model="gradeOrSubject.gradeNums"
            multiple
            collapse-tags
            style="margin-left: 10px"
            placeholder="请选择"
            @change="selGrade"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.gradeNum"
              :label="item.gradeName"
              :value="item.gradeNum"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><span class="title">学科:</span>
          <el-select
            v-model="gradeOrSubject.subjectIds"
            multiple
            collapse-tags
            style="margin-left: 10px"
            placeholder="请选择"
            @change="selSubject"
          >
            <el-option
              v-for="item in subjectList"
              :key="item.subjectId"
              :label="item.subjectName"
              :value="item.subjectId"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          <el-radio-group size="small" v-model="radio1" @change="radio1Change">
            <el-radio-button label="一级分类"></el-radio-button>
            <el-radio-button label="二级分类"></el-radio-button>
          </el-radio-group>
          <el-popover
            style="margin-left: 5px"
            placement="bottom-start"
            :width="radio1 == '一级分类' ? '400' : '700'"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="radio1 == '一级分类' ? NJXKYJFL : NJXKEJFL"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="center">
          <el-radio-group v-model="radio2" @change="radio2Change">
            <el-radio label="活跃明细">活跃明细</el-radio>
            <el-radio label="未活跃明细">未活跃明细</el-radio>
          </el-radio-group>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel"
            >导出数据</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          :key="'AllActiveGradeSubDetail' + keyTable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'functionUse', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{
                (searchForm.pageNum - 1) * searchForm.pageSize +
                scope.$index +
                1
              }}</span>
            </template>
          </el-table-column>
          <template v-if="radio2 == '未活跃明细'">
            <el-table-column
              v-for="(item, index) in tableNotAct"
              :key="index"
              :fixed="item.fixed"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            >
            </el-table-column>
          </template>
          <template v-if="radio1 == '一级分类' && radio2 == '活跃明细'">
            <el-table-column
              v-for="(item, index) in tableLabel1"
              :key="index"
              :fixed="item.fixed"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :sortable="item.sort"
            >
            </el-table-column>
          </template>
          <template v-if="radio1 == '二级分类' && radio2 == '活跃明细'">
            <el-table-column
              v-for="(item, index) in tableLabel2"
              :key="index"
              :fixed="item.fixed"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :sortable="item.sort"
            >
              <el-table-column
                v-for="(item2, index2) in item.children"
                :key="index2"
                :fixed="item2.fixed"
                :label="item2.label"
                :prop="item2.prop"
                :width="item2.width"
                :sortable="item2.sort"
              >
              </el-table-column>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="pagSize">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from '@/components/datePicker/index.vue'
import { isBack } from '@/mixins/isBack.js'
import { lastWeek } from '@/utils/date.js'
import { NJXKYJFL, NJXKEJFL } from '@/utils/explainText.js'
import { resize } from '@/mixins/resize.js'
import { saveAs } from 'file-saver'
import {
  subjectTeaFirstDetail,
  subjectTeaSecondDetail
} from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
export default {
  name: 'AllActiveGradeSubDetail',
  mixins: [isBack, resize],
  components: { datePicker },
  data() {
    return {
      NJXKYJFL: NJXKYJFL,
      NJXKEJFL: NJXKEJFL,
      searchForm: {
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        pageSize: 12,
        pageNum: 1,
        subjectIds: [],
        gradeNums: [],
        schoolId: undefined,
        sortCode: 'functionUse',
        ascOrDes: false //false是降序,true是升序
      },
      gradeOrSubject: {
        schoolId: undefined,
        gradeNums: [],
        subjectIds: []
      },
      gradeList: [],
      subjectList: [],
      tableData: [],
      keyTable: 17,
      loading: false,
      radio1: '一级分类',
      radio2: '活跃明细',
      tableLabel1: [
        {
          prop: 'teacherName',
          label: '教师名称',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'gradeName',
          label: '年级',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'subjectName',
          label: '学科',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'functionUse',
          label: '功能使用度',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'lesson',
          label: '备课',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'classLesson',
          label: '上课',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'tasks',
          label: '作业',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'aiCard',
          label: '智能卡',
          sort: 'custom',
          fixed: false,
          width: ''
        }
      ],
      tableLabel2: [
        {
          prop: 'teacherName',
          label: '教师名称',
          sort: false,
          fixed: true,
          width: ''
        },
        {
          prop: 'gradeName',
          label: '年级',
          sort: false,
          fixed: true,
          width: ''
        },
        {
          prop: 'subjectName',
          label: '学科',
          sort: false,
          fixed: true,
          width: ''
        },
        {
          prop: 'functionUse',
          label: '功能使用度',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: '',
          label: '备课',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'courseModule',
              label: '课程模块',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'management',
              label: '班级管理',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'courseWare',
              label: '备课-查看课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'classCourseWare',
              label: '上传课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'shareCourseWare',
              label: '分享课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'splendidMoment',
              label: '精彩瞬间',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        },
        {
          prop: '',
          label: '上课工具',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'drawingBoard',
              label: '画板',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'projection',
              label: '同步投影',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'timer',
              label: '计时器',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'randomRollCall',
              label: '随机点名',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'randomCourseware',
              label: '使用课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'others',
              label: '其他',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        },
        {
          prop: '',
          label: '作业',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'homework',
              label: '布置作业选题模块',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'knowledge',
              label: '知识点',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'achievement',
              label: '作业-查看成绩',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'publishHteNum',
              label: '布置作业',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'collectHteNum',
              label: '收集作业',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'correctHteNum',
              label: '批改作业',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'explainHteNum',
              label: '讲解作业',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        },
        {
          prop: '',
          label: '智能卡',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'collectAiCard',
              label: '收集智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'correctAiCard',
              label: '批改智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'aiCardAchievement',
              label: '智能卡-查看智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'explainAiCard',
              label: '讲解智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        }
      ],
      tableNotAct: [
        {
          prop: 'teacherName',
          label: '教师名称',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'gradeName',
          label: '年级',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'subjectName',
          label: '学科',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'functionUse',
          label: '功能使用度',
          sort: false,
          fixed: false,
          width: ''
        }
      ],
      total: 0
    }
  },
  created() {
    this.init()
    this.getGradeSubject()
    this.axiosIf()
  },
  beforeDestroy() {
    this.$store.commit('SET_SCHOOLNAME', '')
  },

  methods: {
    init() {
      let info = JSON.parse(this.$route.query.info)
      this.searchForm.startDate = info.startDate
      this.searchForm.endDate = info.endDate
      this.searchForm.schoolId = info.value
      this.gradeOrSubject.schoolId = info.value
      this.$store.commit('SET_SCHOOLNAME', info.label)
    },
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
    },
    radio1Change() {
      this.searchForm.pageNum = 1
      this.keyTable++
      this.searchForm.sortCode = 'functionUse'
      this.searchForm.ascOrDes = false
      this.axiosIf()
    },
    radio2Change() {
      this.searchForm.pageNum = 1
      this.keyTable++
      this.searchForm.sortCode = 'functionUse'
      this.searchForm.ascOrDes = false
      this.axiosIf()
    },
    search() {
      this.searchForm.pageNum = 1
      this.axiosIf()
    },
    reset() {
      this.searchForm = this.$options.data().searchForm
      this.gradeOrSubject = this.$options.data().gradeOrSubject
      this.keyTable++
      this.init()
      this.getGradeSubject()
      this.axiosIf()
    },
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending'
          ? (this.searchForm.ascOrDes = false)
          : (this.searchForm.ascOrDes = true)
        this.axiosIf()
      }
    },
    handleCurrentChange(v) {
      this.axiosIf()
    },
    handleSizeChange(v) {},
    selGrade(v) {
      this.searchForm.gradeNums = this.gradeOrSubject.gradeNums
      this.getGradeSubject()
    },
    selSubject() {
      this.searchForm.subjectIds = this.gradeOrSubject.subjectIds
      this.getGradeSubject()
    },
    // 获取年级学科名称
    getGradeSubject() {
      this.$API.allActiveSchApi
        .getGradeSubject(this.gradeOrSubject)
        .then(res => {
          if (res.result.gradeVoLists[0].gradeName == '0年级') {
            this.gradeList = this.subjectList = []
            return
          }
          this.gradeList = res.result.gradeVoLists
          this.subjectList = res.result.subjectVoLists
        })
    },
    downExcel() {
      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum

      obj.fileName =
        excelName('年级学科教师活跃明细', obj.startDate, obj.endDate) + '.xlsx'
      saveAs(subjectTeaFirstDetail + generateTableParms(obj), obj.fileName)
    },
    axiosIf() {
      if (this.radio1 == '一级分类') {
        this.getSubjectTeaDetailsFirst()
      } else {
        this.getSubjectTeaDetailsSecond()
      }
    },
    // 一级分类
    getSubjectTeaDetailsFirst() {
      this.loading = true

      this.$API.allActiveSchApi
        .getSubjectTeaDetailsFirst(this.searchForm)
        .then(res => {
          if (this.radio2 == '活跃明细') {
            this.tableData = res.result.schoolTeaActive
          } else {
            this.tableData = res.result.schoolTeaNotActive
          }
          if (this.tableData !== null && this.tableData.length > 0) {
            this.total = this.tableData[0].total
            this.tableData.forEach(el => {
              el.alreadyLoggedPercent = el.alreadyLoggedPercent + '%'
              el.activeTeaNumPercent = el.activeTeaNumPercent + '%'
            })
          } else {
            this.tableData = []
            this.total = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 二级分类
    getSubjectTeaDetailsSecond() {
      this.loading = true
      this.$API.allActiveSchApi
        .getSubjectTeaDetailsSecond(this.searchForm)
        .then(res => {
          if (this.radio2 == '活跃明细') {
            this.tableData = res.result.schoolTeaActive
          } else {
            this.tableData = res.result.schoolTeaNotActive
          }
          if (this.tableData !== null && this.tableData.length > 0) {
            this.total = this.tableData[0].total
            this.tableData.forEach(el => {
              el.alreadyLoggedPercent = el.alreadyLoggedPercent + '%'
              el.activeTeaNumPercent = el.activeTeaNumPercent + '%'
            })
          } else {
            this.tableData = []
            this.total = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.allActiveGradeSubDetail {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
